export enum EPreferencePropertyType {
    Unknown = 0,
    PreferenceClass = 1,
    Enum = 2,
    String = 3,
    Boolean = 4,
    Integer = 5,
    Float = 6,
    Double = 7,
    Short = 8,
    UnsignedShort = 9,
    UnsignedInteger = 10,
}

export interface PreferenceEnumItem {
  displayName: string,
  name: string,
}

export interface PreferenceProperty {
  children: PreferenceProperty[],
  description: string,
  displayName: string,
  enumItems: PreferenceEnumItem[],
  isMultiValue: boolean,
  isReadOnly: boolean,
  propertyName: string,
  propertyType: EPreferencePropertyType
  unit: string,
}

export interface PreferenceValue {
  preferenceKey: string,
  preferenceValue: string,
}

export interface PreferenceFile {
  displayName: string,
  name: string,
  properties: PreferenceProperty[],
  values: PreferenceValue[]
}

